import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { InputSelect } from "../../InputSelect/index.js";
const ageText = 'yrs';
const defaultText = 'Required';
function ChildAgeSelect({ index, isHotel = false, value, onChange }) {
    function handleChange(e) {
        onChange(index, e.target.value);
    }
    const options = selectOptions({
        isHotel
    });
    return /*#__PURE__*/ jsx("div", {
        className: "my-2 flex w-full items-center justify-between",
        children: /*#__PURE__*/ jsx("div", {
            className: "flex w-full overflow-hidden text-ellipsis",
            children: /*#__PURE__*/ jsx(InputSelect, {
                size: "sm",
                isAutoWidth: true,
                selectMinWidth: 140,
                selectPadding: 20,
                name: `child-age-${index}`,
                defaultValue: value ?? options[0].value,
                "data-testid": "child-age-select",
                labelText: `Age of Child ${index + 1}`,
                "aria-label": `Select age for child ${index + 1}`,
                options: options,
                onChange: handleChange
            })
        })
    });
}
function selectOptions({ isHotel }) {
    const options = [
        {
            label: defaultText,
            value: ''
        }
    ];
    for(let i = 0; i <= 17; i++){
        let label = `${i} ${ageText}`;
        if (0 === i) label = isHotel ? 'Infant' : '0-1 Infant in lap';
        if (1 === i) label = isHotel ? '1 yr' : '0-1 Infant in seat';
        options.push({
            label,
            value: i + ''
        });
    }
    return options;
}
const TravelerLineItems_ChildAgeSelect = /*#__PURE__*/ memo(ChildAgeSelect);
export { ChildAgeSelect, TravelerLineItems_ChildAgeSelect as default };
